import { versions } from './versions';

export const encoders = {
  versions: {
    ...versions,
  },
};
